<template>
  <div class="statusPage">
    <div class="pageTop">
      <h1>月指标</h1>
      <h2>景区选择</h2>
      <SearchSelect
          className="longSelect"
          v-model="store"
          :options="storeOptions"
          :props="{
         label: 'label',
         value: 'value'
      }"
          placeholder="请选择景区"
      />



<!--      <el-select-->
<!--          multiple-->
<!--          v-model="store" clearable filterable reserve-keyword-->
<!--          class="longSelect"-->
<!--          @change="onSelectChange" ref="el-select"-->
<!--      >-->
<!--        <el-option-->
<!--            v-for="(item, index) in storeOptions"-->
<!--            :key="item.value"-->
<!--            :label="item.label"-->
<!--            :value="item.value"-->
<!--        >-->
<!--        </el-option>-->
<!--      </el-select>-->

      <el-select class="mineSelect" v-model="category" placeholder="请选择" multiple v-collapse-tags="2">
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <h2>年份选择</h2>
      <el-select  v-model="yearVal" placeholder="请选择" >
        <el-option
            v-for="item in yearOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleQuery">查询</el-button>
    </div>

    <div class="outBox">
      <div class="box">
        <div v-loading="loading" element-loading-text="加载数据中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.2)"
             class="mine"></div>
        <div id="main6" class="chart-container"></div>
      </div>
      <div class="box">
        <div v-loading="loading" element-loading-text="加载数据中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.2)"
             class="mine"></div>
        <div id="main7" class="chart-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import SearchSelect from "@/views/components/SearchSelect";

import { getSaleByYear } from '@/api/bi'

export default {
  name: "DeviceStatus",
  data(){
    return {
      store: '',
      category: ['1','2','3','4','5','6','7','8'],
      options: [
        { value: '1', label: '771/772' },
        { value: '2', label: '775' },
        { value: '3', label: '776' },
        { value: '4', label: '779' },
        { value: '5', label: '780' },
        { value: '6', label: '781' },
        { value: '7', label: '782' },
        { value: '8', label: '783' },
      ],
      yearVal: '2026', // 年份
      yearOptions: [
        { value: '2027', label: '2027年' },
        { value: '2026', label: '2026年' },
        { value: '2025', label: '2025年' },
        { value: '2024', label: '2024年' },
        { value: '2023', label: '2023年' },
        { value: '2022', label: '2022年' },
        { value: '2021', label: '2021年' },
        { value: '2020', label: '2020年' },
        { value: '2019', label: '2019年' },
        { value: '2018', label: '2018年' },
        { value: '2017', label: '2017年' },
        { value: '2016', label: '2016年' },
        { value: '2015', label: '2015年' },
        { value: '2014', label: '2014年' },
      ],
      offlineList: [], // 离线设备
      salesStatusList: [], // 设备销售状态
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      lineData: null,
      chartRight: null,
      lineDataRight: {},
    }
  },
  props: ['allStore'], // 全部景区列表
  mounted() {

    this.initData();
    const _this = this;
    this.$nextTick(function () {
      this.$on('resizeMonth', function () {
        if (_this.chart) _this.chart.resize()
        if (_this.chartRight) _this.chartRight.resize()
      })
    });
  },
  methods: {
    // 清除el-select搜索文本框的值query
    // onSelectChange() {
    //   this.$refs['el-select'].query = ''
    // },
    handleQuery(){
      // 查询
      this.initData()
    },
    getData(){
      const params = {
        source: this.category, // 业务来源
        company_id_list: this.store || undefined, // 景区
        year: this.yearVal
      }
      getSaleByYear(params).then(res => {
        if(res && res.code === 2000 && res.data) {
          this.lineData = res.data;
          this.loading = false;
        }
      })

      // 通过异步请求，获取数据
      // this.lineData = {
      //   value: [820, 932, 901, 934, 1290, 1330, 1320,820, 932, 901, 934, 1290, 1330, 1320], // 销售额
      //   sales: [11,22,33,44,55,66,77,88,99,100,110,120],
      //   refundValue: [82, 32, 91, 34, 190, 130, 120,820, 932, 90, 34, 290],
      //   refundRate: [0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,0.10,0.11,0.12]
      // }
    },
    initBar(){
      const _this = this;
      let option = {
        title: {
          text: '销售额&销量',
          color: '#fff',
          top: 16,

          textStyle:{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
          }
        },
        tooltip: { // 悬浮代表的提示初始化
          trigger: 'item',
          formatter: function(params) {
            // 获取当前数据点的名称和值
            let name = params.name; // y轴名称
            let value = params.value; // 数值
            let index = params.dataIndex; // 下标值，方便找从原数据中到对应到的销量

            // 返回提示框的字符串格式
            return `<p>${name}</p><p>销售额：${value}</p><p>销量：${_this.lineData.sales[index]}</p>`
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            inside: false, // y轴名字是否显示在柱状图里面
            zlevel: 2,
            color: '#fff' // y轴名字颜色
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            // 坐标轴轴线相关设置。
            lineStyle: {
              color: '#fff'
            }
          },
          data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
        },
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
              // 坐标轴轴线相关设置。
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {  // 坐标轴上的文字
              color: '#fff',
              margin: 2,
              formatter: function (value, index) {
                if (value >= 10000) {
                  value = value / 10000 + "万";
                }
                return value;
              }
            },
            axisTick:{ // 坐标轴刻度线
              show:true
            },
            splitLine:{
              show:false // 不显示网格线
            },
          }
        ],
        series: [
          {
            name: '销售额&销量',
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.lineData.value, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(0, 255, 255, 0)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(0, 255, 255, 0)'
                  }
                ])
              }
            }

          },

        ],


      };
      let optionsRight = {
        ...option,
        title: {
          text: '退款数&退款率',
          color: '#fff',
          top: 16,

          textStyle:{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
          }
        },
        tooltip: { // 悬浮代表的提示初始化
          trigger: 'item',
          formatter: function(params) {
            // 获取当前数据点的名称和值
            let name = params.name; // y轴名称
            let value = params.value; // 数值
            let index = params.dataIndex; // 下标值，方便找从原数据中到对应到的销量

            // 返回提示框的字符串格式
            return `<p>${name}</p><p>退款数：${value}</p><p>退款率：${(_this.lineData.refundRate[index] * 100).toFixed(2)}%</p>`
          }
        },
        series: [
          {
            name: '销售额&销量',
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: this.lineData.refundValue, // x轴代表的数据
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(0, 255, 255, 0)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(0, 255, 255, 0)'
                  }
                ])
              }
            }

          },

        ],
      }

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
      this.chartRight.setOption(optionsRight);
      // 隐藏加载效果
      // setTimeout(()=> {
      //   this.loading = false;
      // }, 2000)
    },
    async initData(){
      this.loading = true;
      const params = {
        source: this.category, // 业务来源
        company_id_list: this.store || undefined, // 景区
        year: this.yearVal
      }
      await getSaleByYear(params).then(res => {
        if(res && res.code === 2000 && res.data) {
          this.lineData = res.data;
          this.loading = false;
        }
      })

      // 基于准备好的dom，初始化echarts实例
      if(!this.chart || !this.chartRight) {
        this.chart = echarts.init(document.getElementById('main6'));
        this.chartRight = echarts.init(document.getElementById('main7'));
      }
      // 指定图表的配置项和数据
      this.initBar();

    },

    handleSelect(val){ // 接收来自组件的数据
      this.store = val;
    },
  },
  components: {
    SearchSelect
  },
  computed: {
    storeOptions(){
      let arr = [];
      if (!Array.isArray(this.allStore)) return arr;
      this.allStore.map(val => {
        arr.push({label: val.name ,value:val.id });
      })
      return arr;
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    if (this.chartRight) {
      this.chartRight.dispose();
      this.chartRight = null;
    }
  }
}
</script>

<style scoped>

/** {*/
/*  scrollbar-width: thin;*/
/*  scrollbar-color: #58D9F9 #F5F5F5;*/
/*}*/
/* 改变滚动条的宽度和颜色 */
::-webkit-scrollbar {
  background-color: transparent;
  width: 10px;
  border: 1px solid;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background-color: #58D9F9;
  border-radius: 5px;
}

/* 改变滚动条被悬停时的颜色 */
::-webkit-scrollbar-thumb:hover {
  background-color: #7CFFB2;
}

/* 改变滚动条的轨道宽度和颜色 */
::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 5px;
}


.pageTop {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.pageTop h1{
  margin-right: 30px;
  font-size: 22px;
  font-weight: bold;
}

.pageTop h2{
  margin-right: 10px;
}

.pageTop .mineSelect {
  margin: 0 10px;
}

.statusPage,
.deviceBox{
  font-size: 16px;
  color: #ffffff;
  padding: 20px;
  border: 1px solid #5c01b8;
  border-radius: 30px;

}

.statusPage {
  box-shadow: 0 0 10px;
  /*border-color: #58D9F9;*/
  /*margin-top: 30px;*/
  width: 90%;
  margin: 30px auto;
}

.deviceBox {
  display: flex;
  justify-content: space-between;
}




.leftBox,
.rightBox {
  width: 40%;
}

.el-button {
  margin-left: 10px;
}

.el-button:hover {
  color: #ffffff;
  background-color: #5c01b8;
  border-color: #5c01b8;
}

.outBox {
  width: 100%;
  height: 320px;
  display: flex;
  justify-content: space-around;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 40%;
  height: 320px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}
</style>